import { render } from "./InterestAccess.vue?vue&type=template&id=6321e938&ts=true"
import script from "./InterestAccess.vue?vue&type=script&lang=ts"
export * from "./InterestAccess.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devgeorge/andrea/webpage_curaduria2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__